import React, { Component } from 'react';
import FranchisorPayments from '../../payments';
import { withTranslation } from 'react-i18next';
import { paymentOwners } from '../../payments/methods/common';
import queryString from 'query-string';

class Settings extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const { t, location: { search } } = this.props;
		const queryParams = queryString.parse(search);

		return (
			<div>
				<FranchisorPayments panelTitle={t('Settings_PaymentConfiguration')} paymentOwnerType={paymentOwners.franchisor} selectedPaymentMethodName={queryParams.method} />
			</div>
		);
	}
}

export default withTranslation()(Settings);